import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SectionLayout from '@common/containers/layouts/SectionLayout';
import EnglishImprint from '@common/routes/Imprint/EnglishImprint';
import GermanImprint from '@common/routes/Imprint/GermanImprint';

function Imprint() {
  const { i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <SectionLayout style={{ maxWidth: '824px' }}>
      {i18n.resolvedLanguage === 'de-DE' ? <GermanImprint /> : <EnglishImprint />}
    </SectionLayout>
  );
}

export default Imprint;
